import { Link } from "react-router-dom";

function RelatedServices({ page }) {
    const links = {

    tempo: [
        {
            title: "Force Urbania On Rent in Pune",
            link: "/force-urbania-on-rent-in-pune"
        },
        {
            title: "Bus Rental in Pune",
            link: "/bus-rental-in-pune"
        },
        {
            title: "Bus Service for Corporate Pune",
            link: "/Bus-Service-for-Corporate-Pune"
        },
        {
            title: "Amruta Travels",
            link: "/amruta-travels"
        }
    ],

    urbania: [
        {
            title: "Tempo Traveller Hire in Pune",
            link: "/tempo-traveller-hire-in-pune"
        },
        {
            title: "Bus Rental in Pune",
            link: "/bus-rental-in-pune"
        },
        {
            title: "Bus Service for Corporate Pune",
            link: "/Bus-Service-for-Corporate-Pune"
        },
        {
            title: "Amruta Travels",
            link: "/amruta-travels"
        }
    ],

    corporate: [
        {
            title: "Bus Rental in Pune",
            link: "/bus-rental-in-pune"
        },
        {
            title: "Tempo Traveller Hire in Pune",
            link: "/tempo-traveller-hire-in-pune"
        },
        {
            title: "Force Urbania On Rent in Pune",
            link: "/force-urbania-on-rent-in-pune"
        },
        {
            title: "Amruta Travels",
            link: "/amruta-travels"
        }
    ],

    busrental: [
        {
            title: "Tempo Traveller Hire in Pune",
            link: "/tempo-traveller-hire-in-pune"
        },
        {
            title: "Force Urbania On Rent in Pune",
            link: "/force-urbania-on-rent-in-pune"
        },
        {
            title: "Bus Service for Corporate Pune",
            link: "/Bus-Service-for-Corporate-Pune"
        },
        {
            title: "Amruta Travels",
            link: "/amruta-travels"
        }
    ],

    location: [
        {
            title: "Bus Rental in Pune",
            link: "/bus-rental-in-pune"
        },
        {
            title: "Tempo Traveller Hire in Pune",
            link: "/tempo-traveller-hire-in-pune"
        },
        {
            title: "Force Urbania On Rent in Pune",
            link: "/force-urbania-on-rent-in-pune"
        },
        {
            title: "Bus Service for Corporate Pune",
            link: "/Bus-Service-for-Corporate-Pune"
        }
    ],

    brand: [
        {
            title: "Bus Rental in Pune",
            link: "/bus-rental-in-pune"
        },
        {
            title: "Tempo Traveller Hire in Pune",
            link: "/tempo-traveller-hire-in-pune"
        },
        {
            title: "Force Urbania On Rent in Pune",
            link: "/force-urbania-on-rent-in-pune"
        },
        {
            title: "Bus Service for Corporate Pune",
            link: "/Bus-Service-for-Corporate-Pune"
        }
    ]

};

const currentLinks = links[page] || [];

return (
        <div className="container mt-5 mb-5">

            <h2 className="darkcolorrr mb-4">
Explore Related Travel Services in Pune
</h2>

            <div className="row">

    {currentLinks.map((item, index) => (

        <div className="col-md-6 mb-3" key={index}>

            <Link
    to={item.link}
    className="text-decoration-none d-block border rounded p-3 h-100 shadow-sm"
    style={{
        transition: "0.3s",
        color: "#322E77",
        fontWeight: "600"
    }}
>
    <>
    {item.title}
    <span className="float-end">→</span>
</>
</Link>

        </div>

    ))}

</div>

        </div>
    );
}

export default RelatedServices;